<template>
  <el-dialog title="Reajustar Aluguel" :visible.sync="visibility" @open="iniciar" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="30%">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item>
            <template slot="label">
              <strong style="font-size: 15px">
                Valor Atual  
              </strong
            ></template>
            <div class="el-input el-input--small">
              <money
                v-model="aluguel.valor"
                v-bind="money"
                readonly
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 5px">
        <el-col>
          <el-form-item>
            <template slot="label">
              <strong style="font-size: 15px">Reajuste</strong>
            </template>
            <el-switch
              v-model="percentualReajusteIsSelecionado"
              inactive-text="Valor"
              active-text="Percentual"
              active-color="#008080"
              inactive-color="#008080"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="percentualReajusteIsSelecionado" :gutter="10">
        <el-col :span="10">
          <el-form-item>
            <el-input
              v-model="percentualReajuste"
              @input="calcularNovoValor"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ this.formatarValor(novoValor) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row v-else :gutter="10">
        <el-col :span="10">
          <el-form-item>
            <el-input
              v-model="novoValor"
              @input="calcularPercentualReajuste"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="prepend">R$</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ this.formatarPercentual(percentualReajuste) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 20px">
        <el-col>
          <el-form-item>
            <template slot="label">
              <strong style="font-size: 15px">Desconto por Pontualidade</strong>
            </template>
            <el-switch
              v-model="percentualPontualidadeIsSelecionado"
              inactive-text="Valor do Desconto"
              active-text="Percentual do Desconto"
              active-color="#008080"
              inactive-color="#008080"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="percentualPontualidadeIsSelecionado" :gutter="10">
        <el-col :span="10">
          <el-form-item prop="desconto">
            <el-input
              v-model="percentualDesconto"
              @input="calcularValorDescontoPontualidade"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ this.formatarValor(valorDesconto) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row v-else :gutter="10">
        <el-col :span="10">
          <el-form-item prop="valorDesconto">
            <el-input
              v-model="valorDesconto"
              @input="calcularPercentualDescontoPontualidade"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="prepend">R$</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ this.formatarPercentual(percentualDesconto) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 5px">
        <el-col :md="6" :lg="8" :span="5">
          <el-form-item prop="diasDesconto">
            <template slot="label">
              <strong style="font-size: 15px">
                Antecedência
              </strong>
            </template>
            <el-input
              auto-complete="off"
              v-model="diasDesconto"
            >
              <template slot="append">
                dias
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button @click="confirmarReajustarHandler" type="primary" size="small" round class="btn-box-shadow">Concluir</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapState } from "vuex";
import { Money } from "v-money";
import Util from "../../../util/funcoes.js";

export default {
  components: {
    Money
  },
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      percentualReajuste: 0,
      novoValor: 0,

      valorDesconto: 0,
      percentualDesconto: 0,
      diasDesconto: 0,

      percentualReajusteIsSelecionado: false,
      percentualPontualidadeIsSelecionado: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore",["reajustarAluguel"]),

    iniciar() {
      this.calcularNovoValor();
      this.recuperarInformacoesDesconto();
    },

    confirmarReajustarHandler() {
      this.$confirm("Após a efetivação do reajuste, serão criados novos recibos conforme a quantidade de meses no campo Reajuste em Detalhes do contrato. Você tem certeza que deseja confirmar o reajuste?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.reajustar();
        });
		},

    reajustar(){
      if(!this.novoValor || parseFloat(this.novoValor) <= 0){
        this.$message.info("Informe um valor acima de R$ 0,00.");
        return
      }

      let payload;

      payload = { 
        id: this.aluguel.id,
        valor: this.novoValor,
        desconto: this.percentualDesconto,
        valorDesconto: this.valorDesconto,
        diasDesconto: this.diasDesconto,
        percentualReajuste: this.percentualReajuste
      }

      this.showLoading();
      this.reajustarAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            default:
              this.$message.warning(resultado.mensagem);
          }
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },

    recuperarInformacoesDesconto() {
      this.valorDesconto = this.aluguel.valorDesconto;
      this.percentualDesconto = this.aluguel.desconto;
      this.diasDesconto = this.aluguel.diasDesconto;
    },

    calcularNovoValor() {
      const valorReajustado = (this.aluguel.valor + (this.aluguel.valor * (this.percentualReajuste/100))).toFixed(2);
      if(isFinite(valorReajustado)) {
        this.novoValor = valorReajustado;
      } else {
        this.novoValor = this.aluguel.valor;
      }

      this.calcularValorDescontoPontualidade();
    },
    calcularPercentualReajuste() {
      const percentual = (((this.novoValor*100) / this.aluguel.valor) - 100).toFixed(2);
      if(isFinite(percentual)) {
        this.percentualReajuste = percentual;
      } else {
        this.percentualReajuste = 0;
      }

      this.calcularValorDescontoPontualidade();
    },

    calcularValorDescontoPontualidade() {
      if(this.aluguel.valor > 0) {
        const desconto = ((this.novoValor * this.percentualDesconto)/100).toFixed(2);
        if(isFinite(desconto)) {
          this.valorDesconto = desconto;
        } else {
          this.valorDesconto = 0;
        }
      }
    },
    calcularPercentualDescontoPontualidade() {
      const percentual = ((this.valorDesconto*100) / this.novoValor).toFixed(2);
      if(isFinite(percentual)) {
        this.percentualDesconto = percentual;
      } else {
        this.percentualDesconto = 0;
      }
    },

    validarSeparadorDecimal(event) {
      const textoDigitado = event.target.value;
      
      const textoComVirgulasTratadas = this.substituirTodaVirgulaPorPonto(textoDigitado);
      const textoComPontosTratados = this.removerTodosOsPontosDepoisDoPrimeiro(textoComVirgulasTratadas);

      const textoFinal = textoComPontosTratados;

      event.target.value = textoFinal;
    },

    validarInputNumerico(event) {
      const valorDigitado = event.key;
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
      const valorNaoEhPermitido = !valoresPermitidos.includes(valorDigitado);

      if(valorNaoEhPermitido) event.preventDefault();
    },

    substituirTodaVirgulaPorPonto(texto) {
      return texto.replace(/,/g, '.');
    },
    removerTodosOsPontosDepoisDoPrimeiro(texto) {
      return texto.replace(/(?<=\..*)\./g, '');
    },

    formatarValor(valor) {
      return Util.formatarValor(valor);
    },
    formatarPercentual(valor) {
      return Util.formatarPercentual(valor);
    },

    reset() {
      this.percentualReajuste = 0;
      this.percentualDesconto = 0;
    },

    fechar() {
      this.reset();
      
      this.$emit('close');
    }, 
  }
}
</script>
